module.exports = __webpack_public_path__ + "static/media/Lideco.a398ac5c.png";